import localKey from './localKey'

const devApiUrl = '/';

const proApiUrl = 'https://sk-m.api.fxzb.vip';
// const proApiUrl = 'https://dev.sk-m.api.fxzb.vip';
// const proApiUrl = 'http://192.168.110.201:8209'; 
// const proApiUrl = 'http://192.168.110.48:8017'; 
// const proApiUrl = 'http://172.16.3.165:8209'; 
const nodeDevEnv = process.env.NODE_ENV == 'development' ? true : false;
// wss://sk-m.api.fxzb.vip
const wssUrl = 'wss://sk-m.api.fxzb.vip'
// const wssUrl = 'ws://dev.sk-m.api.fxzb.vip'
// const wssUrl = 'ws://192.168.110.124:8804'
export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    socketUrl:  wssUrl,
    siteName: '供应商管理后台',
    minSiteMame: 'C',
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 10000,
    cookiesExpires: 7,
    requestRetry: 3,
    requestRetryDelay: 800,
    tokenKey: 'Authorization',
    userInfoKey: 'USER_INFO',
    ...localKey
}